'use client';

import classNames from 'classnames';

import { EventCard } from '~components/EventCard/EventCard';
import { Section } from '~components/Section/Section';
import { EventRegistrationForm } from '~containers/Forms/EventRegistrationForm/EventRegistrationForm';
import { EventUtils } from '~helpers/eventUtils';

import styles from './SectionEvent.module.scss';
import { SectionEventProps } from './SectionEvent.types';

export const SectionEvent = ({
  className,
  hash,
  hasForm,
  event,
  form,
  offlineRegistrationClosed,
  ...sectionProps
}: SectionEventProps) => {
  return (
    <Section hash={hash} className={className} {...sectionProps}>
      <div
        className={classNames(styles.event, {
          [styles.hasForm]: hasForm,
        })}
      >
        <EventCard {...event} hasForm={hasForm} />
        {hasForm && (
          <section className={styles.form}>
            <EventRegistrationForm
              {...form}
              event={{
                ...event,
                formats: EventUtils.checkOfflineFormat(
                  event.formats,
                  offlineRegistrationClosed,
                ),
              }}
            />
          </section>
        )}
      </div>
    </Section>
  );
};
